import { useState } from 'react';
import WhatsAppModal from './WhatsAppModal';

export default function FloatingButtons() {
  const [modalOpen, setModalOpen] = useState(false);

  const handleConfirm = () => {
    setModalOpen(false);
    window.open('https://wa.me/5514981800454', '_blank', 'noopener,noreferrer');
  };

  return (
    <>
      <WhatsAppModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        onConfirm={handleConfirm}
      />

      {/* WhatsApp Floating Button */}
      <button
        onClick={() => setModalOpen(true)}
        className="fixed bottom-6 right-6 z-50 bg-transparent border-none p-0"
      >
        <div className="relative group cursor-pointer">
          <div className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold px-2 py-1 rounded-full animate-pulse">
            Online
          </div>
          <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center shadow-2xl hover:shadow-green-500/50 hover:scale-110 transition-all animate-pulse">
            <i className="ri-whatsapp-fill text-white text-3xl"></i>
          </div>
          <div className="absolute right-full mr-4 top-1/2 -translate-y-1/2 bg-black text-white px-4 py-2 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
            Fale no WhatsApp
            <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-full border-8 border-transparent border-l-black"></div>
          </div>
        </div>
      </button>

      {/* Emergency Button */}
      <button
        onClick={() => setModalOpen(true)}
        className="fixed bottom-6 left-6 z-50 bg-transparent border-none p-0"
      >
        <div className="relative group cursor-pointer">
          <div className="bg-red-600 text-white font-bold px-4 py-3 md:px-6 md:py-4 rounded-full shadow-2xl hover:shadow-red-600/50 hover:scale-105 transition-all flex items-center gap-2 md:gap-3 animate-pulse">
            <i className="ri-alarm-warning-fill text-xl md:text-2xl"></i>
            <span className="text-sm md:text-lg whitespace-nowrap">EMERGÊNCIA</span>
          </div>
          <div className="absolute left-full ml-4 top-1/2 -translate-y-1/2 bg-black text-white px-4 py-2 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none hidden md:block">
            Chamar no WhatsApp
            <div className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-full border-8 border-transparent border-r-black"></div>
          </div>
        </div>
      </button>
    </>
  );
}
